import {useMutation} from '@tanstack/react-query';
import {postRegister} from '../operations/post-register';
import {useToast} from '@/hooks/use-toast';

export function usePostRegisterMutation() {
  const {showErrorToast} = useToast();

  return useMutation({
    mutationKey: ['postRegister'],
    mutationFn: postRegister,
    onError() {
      showErrorToast('エラーが発生しました。再度お試しください。');
    },
  });
}
